<template>
  <nav
    class="navbar navbar-expand-lg row-shadow"
    style="background: var(--darkbackground4);"
    v-bind:class="[!selectedNavLinkBoolean ? 'light_shadow' : 'blue_shadow']"
  >
    <router-link :to="{ name: 'home' }" class="navbar-brand navbar-home">
      <img
        :src="logo"
        @mouseover="logo = logo_blue"
        @mouseout="logo = logo_white"
        alt=""
        style="padding: 0 10px 0 10px; image-rendering: crisp-edges; height: 20px"
      />
    </router-link>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="" role="button"
        ><i
          class="fa fa-bars"
          aria-hidden="true"
          style="color:var(--textinactive)"
        ></i
      ></span>
    </button>

    <div
      class="collapse navbar-collapse"
      id="navbarSupportedContent"
      v-if="user.habeas_data === true"
    >
      <!-- Router Link -->
      <RouterLinkComponent :analysis="analysis" />
      <!-- End Router Link -->
      <ul class="navbar-nav my-2 my-lg-0 mr-1 txt-label-primary-2 navbar-end">
        <!--profile & logout-->
        <li class="txt-label-primary-2" v-show="selectedNavLink !== null">
          <label
            :for="'selectAsset'"
            class="toggle__button_nav"
            style="height: 100%"
            :class="{ actives: selectedNavLinkBoolean }"
          >
            <input
              type="checkbox"
              @click="onUserSelectNavLinkBoolean"
              :id="'selectAsset'"
              v-model="selectedNavLinkBoolean"
            />
            <span class="toggle__switch_nav">
              <div class="row f-row justify-content-center">
                <div
                  class="col col-6 txt-label-primary-2 text-center toggles"
                  style=" top: 1px;"
                >
                  Currencies
                </div>
                <div
                  class="col col-6 txt-label-primary-2 text-center toggles"
                  style=" top: 1px;"
                >
                  Commodities
                </div>
              </div>
            </span>
          </label>
        </li>
        <li class="txt-label-primary-2">
          <label
            :for="'colors_button'"
            class="toggle__button_rt ml-3"
            style="height: 100%"
            :class="{ actives: newColorTheme }"
            id="colors-btns"
          >
            <input
              type="checkbox"
              @click="onUserChangeColor"
              :id="'colors_button'"
              v-model="newColorTheme"
            />
            <span class="toggle__switch_rt">
              <div class="row f-row justify-content-center">
                <div
                  class="col col-6 txt-label-primary-2 text-center toggles"
                  style=" top: 1px;"
                  id="container-light"
                >
                  Light
                </div>
                <div
                  class="col col-6 txt-label-primary-2 text-center toggles"
                  style=" top: 1px;"
                  id="container-light2"
                >
                  Dark
                </div>
              </div>
            </span>
          </label>
        </li>

        <li class="borderLeft ml-3 container-profile">
          <router-link
            :to="{ name: 'profile' }"
            class="nav-link mr-2 ml-2"
            style="padding-right: 0"
            v-bind:class="[
              analysis === 'PROFILE' ? 'link-selected nav-item' : 'nav-item'
            ]"
          >
            <span v-if="user.first_name"
              >{{ user.first_name }} {{ user.last_name }}</span
            >
            <span v-else>Welcome</span>
            <img
              v-if="userAvatar"
              :src="userAvatar"
              alt="company"
              class="ml-2 logo__company-user"
              :style="{
                width: widthAvatar + 'px',
                height: heightAvatar + 'px'
              }"
            />
            <i v-else class="fa fa-user ml-2"></i>
          </router-link>
        </li>

        <li>
          <router-link
            :to="{ name: 'tutorials' }"
            class="nav-link mr-2 btn"
            style="padding: 0 0 0 5px"
            v-bind:class="[
              analysis === 'TUTORIALS' ? 'link-selected nav-item' : 'nav-item'
            ]"
          >
            <i
              class="fa fa-question-circle txt-label-primary-2"
              style="display: inline; font-size: 1.3rem;"
            ></i>
          </router-link>
        </li>

        <li
          class="nav-item nav-link ml-2 borderLeft"
          style="padding: 3px 0 0 12px; cursor: pointer;"
        >
          <a v-on:click="logout()"
            ><span
              class="fa fa-power-off"
              aria-hidden="True"
              style="font-size:1.5rem"
            ></span>
          </a>
        </li>
      </ul>
    </div>
    <!-- <div class="collapse navbar-collapse"> -->
    <div class="collapse navbar-collapse" v-else>
      <ul class="navbar-nav ml-auto" style="padding: 0;">
        <!--profile & logout-->
        <li class="nav-item container-profile">
          <router-link
            :to="{ name: 'profile' }"
            class="nav-link mr-2"
            style="padding-right: 0"
            v-bind:class="[
              analysis === 'PROFILE'
                ? 'link-selected nav-item borderLeft'
                : 'nav-item borderLeft'
            ]"
          >
            <span v-if="user.first_name" style="padding-left: 8px"
              >{{ user.first_name }} {{ user.last_name }}:</span
            >
            <span v-else style="padding-left: 8px">Welcome:</span>
            <img
              v-if="userAvatar"
              :src="userAvatar"
              alt="company"
              class="ml-2 logo__company-user"
              :style="{
                width: widthAvatar + 'px',
                height: heightAvatar + 'px'
              }"
            />
            <i v-else class="fa fa-user ml-2"></i>&nbsp;
            <!--                            <span class="badge badge-pill">1  &lt;!&ndash;TODO: aca va la cantidad de alertas&ndash;&gt;-->
            <!--                            </span>-->
            &nbsp; (pending information)
          </router-link>
        </li>

        <li
          class="nav-item nav-link ml-2 borderLeft"
          style="padding-left: 20px; padding-right: 0; cursor: pointer;"
        >
          <a v-on:click="logout()"
            ><span class="fa fa-power-off" aria-hidden="True"></span>
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { colorThemeChange } from "@/_core/_helpers/_helpers";
import RouterLinkComponent from "@/components/router_link/RouterLinkComponent.vue";

export default {
  name: "NavbarComponent",
  components: {
    RouterLinkComponent
  },
  props: {
    analysis: { type: String, required: true },
    colorTheme: { required: true, type: Boolean, default: true },
    selectedNavLink: { required: false, default: null },
    user: { required: true }
  },
  data() {
    return {
      newColorTheme: true,
      root: document.documentElement,
      logo_white: require("@/assets/images/QuanspireLogoWhite.svg"),
      logo_blue: require("@/assets/images/QuanspireLogoBlue.svg"),
      logo: require("@/assets/images/QuanspireLogoWhite.svg"),
      myDataLinks: ["Program", "Exposures", "Hedges", "Relations"],
      myDataLabel: "My Data",
      widthAvatar: 0
    };
  },
  mounted() {
    this.newColorTheme = this.colorTheme;
    if (this.newColorTheme) {
      this.logo_white = require("@/assets/images/QuanspireLogoWhite.svg");
      this.logo = require("@/assets/images/QuanspireLogoWhite.svg");
    } else if (!this.newColorTheme) {
      this.logo_white = require("@/assets/images/QuanspireLogoBlack.svg");
      this.logo = require("@/assets/images/QuanspireLogoBlack.svg");
    }
  },
  watch: {
    colorTheme(val) {
      this.newColorTheme = val;
      if (this.newColorTheme) {
        this.logo_white = require("@/assets/images/QuanspireLogoWhite.svg");
        this.logo = require("@/assets/images/QuanspireLogoWhite.svg");
      } else if (!this.newColorTheme) {
        this.logo_white = require("@/assets/images/QuanspireLogoBlack.svg");
        this.logo = require("@/assets/images/QuanspireLogoBlack.svg");
      }
    },
    analysis(val) {
      if (val === "DATA") {
        this.myDataLabel = "My Data | " + this.myDataLinks[0];
        this.$emit("eventOnClientSelect", 0);
      }
    }
  },
  computed: {
    selectedNavLinkBoolean: {
      get() {
        return this.selectedNavLink === 1;
      },
      set() {
        return false;
      }
    },
    userAvatar() {
      const imageUrl = this.$store.state.user.all.items?.user_avatar;

      if (imageUrl) {
        this.getMeasures(imageUrl);
        return imageUrl;
      } else return null;
    },
    heightAvatar() {
      return window.innerWidth <= 1280 ? 16 : 27;
    }
  },
  methods: {
    onUserChangeColor() {
      let clrTheme = !this.newColorTheme;
      if (clrTheme) {
        this.logo_white = require("@/assets/images/QuanspireLogoWhite.svg");
        this.logo = require("@/assets/images/QuanspireLogoWhite.svg");
      } else if (!clrTheme) {
        this.logo_white = require("@/assets/images/QuanspireLogoBlack.svg");
        this.logo = require("@/assets/images/QuanspireLogoBlack.svg");
      }
      colorThemeChange(this.root, clrTheme);
      this.$emit("eventOnUserColorTheme", clrTheme);
    },
    onUserSelectNavLinkBoolean() {
      this.$emit("eventOnUserSelectNavLink", 1 - this.selectedNavLink);
    },
    onClientSelect(idx) {
      this.$emit("eventOnClientSelect", idx);
    },
    logout() {
      this.$store.dispatch("authentication/logout");
      this.$store.dispatch("user/logout");
      this.$store.dispatch("companies/logout");
      this.$store.dispatch("commodities/logout");
      this.$store.dispatch("currencies/logout");
      this.$store.dispatch("countries/logout");
      this.$store.dispatch("currencies_intraday_history/logout");
      this.$store.dispatch("total_currency_exposure/logout");
      this.$router.push("/landing/es");
    },
    getMeasures(imageUrl) {
      const _this = this;
      const img = new Image();
      img.src = imageUrl;

      img.onload = function() {
        const widthImage = img.naturalWidth;
        const heightImage = img.naturalHeight;
        _this.widthAvatar = (_this.heightAvatar * widthImage) / heightImage;
      };
    }
  }
};
</script>

<style scoped>
.toggle__button_nav {
  margin: 0 1rem 0 0 !important;
}
@media (max-width: 1100px) {
  .toggle__button_nav {
    margin: 0 !important;
  }
}
.light_shadow {
  box-shadow: inset 0 8px 6px -6px var(--expo-navbar) !important;
}
.blue_shadow {
  box-shadow: inset 0 8px 6px -6px var(--hedge-navbar) !important;
}
</style>
